// extracted by mini-css-extract-plugin
export default {"files":"dealer-contracts_files__v7GiC","file":"dealer-contracts_file__PBC+M","uploadBox":"dealer-contracts_uploadBox__iRVxo","uploadText":"dealer-contracts_uploadText__P4Fx-"};